import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

export const useOnePortProductCatalogue = () => {
    return useQuery(queries.onePortProductCatalogue.latest);
};
